import { Outlet, useNavigate, useLocation } from 'react-router';
import { useTelegram } from '../hooks/useTelegram';
import { useMemo, useEffect } from 'react';
import { useAppSettings } from '../stores/appSettings';
import { getBotInfo } from '../utils/api';

export function Layout(): React.JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { initData } = useTelegram();
  const { currentRole, setCurrentRole, setCurrentBusinessId } = useAppSettings();

  // Синхронизация роли с сервером при загрузке
  useEffect(() => {
    async function syncProfile() {
      if (!initData) return;
      const res = await getBotInfo(initData);
      if (res.ok) {
        setCurrentRole(res.value.profile.role);
        setCurrentBusinessId(res.value.profile.businessId);
      }
    }
    syncProfile();
  }, [initData, setCurrentRole, setCurrentBusinessId]);

  // Разные меню для разных ролей согласно ТЗ
  const navItems = useMemo(() => {
    // 1. Super Admin (Платформа)
    if (currentRole === 'admin') {
      return [
        { path: '/', label: 'Метрики', icon: '📊' },
        { path: '/owners', label: 'Владельцы', icon: '👥' },
        { path: '/ai-agents', label: 'Агенты', icon: '🤖' },
        { path: '/logs', label: 'Логи', icon: '📜' },
        { path: '/billing', label: 'Тарифы', icon: '💎' },
      ];
    }

    // 2. Business Owner
    if (currentRole === 'owner') {
      return [
        { path: '/', label: 'Аналитика', icon: '📈' },
        { path: '/bookings', label: 'Записи', icon: '📅' },
        { path: '/staff', label: 'Команда', icon: '👥' },
        { path: '/reviews', label: 'Отзывы', icon: '⭐' },
        { path: '/settings', label: 'Настройки', icon: '⚙️' },
      ];
    }

    // 3. Manager / Senior Manager
    if (currentRole === 'manager') {
      return [
        { path: '/', label: 'Обзор', icon: '📊' },
        { path: '/bookings', label: 'Все записи', icon: '📅' },
        { path: '/staff', label: 'Мастера', icon: '👥' },
        { path: '/reviews', label: 'Отзывы', icon: '💬' },
      ];
    }

    // 4. Staff / Master
    return [
      { path: '/', label: 'Мой график', icon: '📅' },
      { path: '/bookings', label: 'Мои записи', icon: '📝' },
      { path: '/settings', label: 'Профиль', icon: '👤' },
    ];
  }, [currentRole]);

  const roleLabels: Record<string, string> = {
    admin: 'SUPER ADMIN 🛡️',
    owner: 'ВЛАДЕЛЕЦ 🏢',
    manager: 'МЕНЕДЖЕР 👔',
    master: 'МАСТЕР ✂️',
    assistant: 'ПОМОЩНИК 🤝'
  };

  return (
    <div className="container">
      <header className="header-status">
        <div className="status-item">
          <span className="status-label">Роль</span>
          <span className="status-value">{roleLabels[currentRole] || 'ГОСТЬ'}</span>
        </div>
        <div className="status-item" style={{ textAlign: 'right' }}>
          <span className="status-label">Система</span>
          <span className="status-value" style={{ color: '#34C759' }}>Online 🟢</span>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <nav className="tab-bar">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`tab-item ${isActive ? 'active' : ''}`}
            >
              <span className="tab-icon">{item.icon}</span>
              <span className="tab-label">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
